import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = { mode: "light" };

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<string>) => {
      state.mode = action.payload;
    },
  },
});

export const { setTheme } = themeSlice.actions;
const reducer = themeSlice.reducer;

export default reducer;
